import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, DestroyRef, effect, EffectRef, ElementRef, HostListener, inject, OnDestroy, OnInit, signal, ViewChild, ViewEncapsulation, WritableSignal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';

import { ActivatedRoute, Router } from '@angular/router';
import { CountableTimeZonePipe, MenuItems } from 'countable@helpers';
import { DIALOG_MESSAGES, DIALOG_TYPES, DialogScheduleModel, GenericResModel, ROW_TYPES, TrialBalanceScheduleModel, UserModel } from 'countable@model';
import { FsExportService } from 'countable@services';
import { ToastrService } from 'ngx-toastr';
import { of, skip, Subject, Subscription, switchMap } from 'rxjs';
import { catchError, debounceTime, take } from 'rxjs/operators';
import { ResizeModel } from 'src/app/model/eng/resize.model';
import { ScheduleUtil } from '../../../helpers/schedule/schedule-util';
import { AclModel } from '../../../model/acl.model';
import { AclService } from '../../../services/acl.service';
import { AuthService } from '../../../services/auth.service';
import { EngApiService } from '../../../services/eng-api.service';
import { ScheduleService } from '../../../services/schedule.service';
import { WorkbookService } from '../../../services/workbook.service';
import { UnsavedChangesDialogComponent } from '../../dialogs/unsavedChangesDialog/unsavedChangesDialog.component';
import { SchedulesDialogComponent } from '../../remote-shared/schedules/schedules-dialog/schedules-dialog.component';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'app-trail-balance-working-sheet',
  templateUrl: './trail-balance-working-sheet.component.html',
  styleUrls: ['./trail-balance-working-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class TrailBalanceWorkingSheetComponent implements OnInit {
  @ViewChild('centerSection', {static: false}) centerSection!: ElementRef;
  @ViewChild('leftPanel', {static: false}) leftPanel!: ElementRef;
  @ViewChild('togglePanel', {static: false}) togglePanel!: ElementRef;
  @ViewChild('drawer') drawer!: MatDrawer;

  engagementData: any;
  engagementName: any;
  clientName: any;
  yearEnd: any;
  isSideMenuExpanded: boolean = true;
  isPreviewPanelExpanded: boolean = false;
  selectedEngagementDataCopy: any;
  engfinsettingid: any;
  isyesno: any;
  engagementID: any;
  ntrMenuData: any;
  compilationType: string;
  typeOfEntityId: number;
  hideRightSidePanel: boolean = false;
  workBookLeftSideMenu: any = [];
  isEditableMenu: boolean = false;
  subModuleId: any;
  isOldSubModuleName: string = '';
  user: UserModel;
  shortCutMenuDetails: any;
  acl: AclModel;
  public leftSideMenuSchedules: any;
  private destroyRef = inject(DestroyRef);
  protected readonly kebabMenuItem = MenuItems;
  public scheduleUtil: typeof ScheduleUtil = ScheduleUtil;
  public isSyncCall: WritableSignal<boolean> = signal<boolean>(false);
  public isExpandSchedule: WritableSignal<boolean> = signal<boolean>(false);
  public selectedSchedule: WritableSignal<string> = signal<string>(null);
  private syncSubject = new Subject<any>();

  @HostListener('window:storage', ['$event'])
  onStorageChange(ev: StorageEvent) {
    if (ev.key == 'RetainedEarningStatement') {
      this.getWBLeftSideMenu();
    }
    if (ev.key == 'adjustmentEntrySaved') {
      this.getWBLeftSideMenu();
    }
    if (ev.key == 'RetainedEarningStatement') {
    this.isyesno = parseInt(localStorage.getItem('isyesno'));
    this.getNtrMenuData();
    }
    if(ev.key ==='refreshWorkbookPreview' && ev.newValue) {
      this.fsService.removeAllFsDocs();
      this.shareService.clearAllRefreshValues();
      const refreshMap = this.shareService.refreshWorkbookPreview(this.router.url);
      this.shareService.updateFinStatement$.next(refreshMap);
      localStorage.removeItem('refreshWorkbookPreview');
    }
  }

  // Method to handle clicks outside
  @HostListener('document:click', ['$event.target'])
  @HostListener('document:touchstart', ['$event.target'])
  onClickOutside(target: HTMLElement): void {
    const isInside = this.centerSection.nativeElement.contains(target);
    const isLeftPanel = this.leftPanel.nativeElement.contains(target);
    const isTogglePanel = this.togglePanel.nativeElement.contains(target);
    if (window.innerWidth < 991 && isInside && !isLeftPanel && !isTogglePanel) {
      this.drawer.close();
    }
  }

  constructor(private authService: AuthService, private aclService: AclService, public router: Router,
              public shareService: SharedService, public dialog: MatDialog,
              public toaster: ToastrService, private fsService: FsExportService, private engApiService: EngApiService,
              private wbService: WorkbookService, private scheduleService: ScheduleService, private countableTimeZonePipe: CountableTimeZonePipe, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.scheduleService.refresh$.pipe(takeUntilDestroyed(this.destroyRef), skip(1)).subscribe(res=>{
      this.getLeftSideMenuSchedules(res);
    });

    this.scheduleService.syncSchedule$.pipe(takeUntilDestroyed(this.destroyRef), skip(1)).subscribe(res=>{
      if(res){
        res?.isSync ? this.scheduleSyncAll(res?.uuid) : this.getLeftSideMenuSchedules(res, true);
      }
    });

    this.scheduleService.resetSchedule$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res=>{
      if(res){
        this.getLeftSideMenuSchedules(res);
      }
    });

    this.scheduleService.reorderSchedule$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res=>{
      res && this.updateSortOrder(res);
    });

    this.scheduleService.syncCallSpinner$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value=>{
      this.isSyncCall.set(value);
    });

    this.authService.subjectUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => {
      this.user = user;
    });
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(acl => {
      this.acl = acl;
    });
    this.shareService.updateFInancialSettings.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      this.getWBLeftSideMenu();
    })
    this.shareService.refreshWorkbookmenu.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if(res === true){
        this.getWBLeftSideMenu();
      }
    });
    this.engagementData = JSON.parse(localStorage.getItem("selectedEngagementObj"));
    localStorage.setItem('isWorkBook','true');
    this.selectedEngagementDataCopy = JSON.parse((localStorage.getItem('selectedEngagementObjCopy')));
    this.shortCutMenuDetails = JSON.parse(localStorage.getItem('shortCutMenuDetails'));
    this.engagementName = this.selectedEngagementDataCopy.engagementName;
    this.engagementID = localStorage.getItem('engagementID');
    this.clientName = this.selectedEngagementDataCopy.clientName;
    this.yearEnd = this.selectedEngagementDataCopy.yearEnd;
    this.compilationType = this.selectedEngagementDataCopy.compilationtype;
    this.typeOfEntityId = this.selectedEngagementDataCopy.typeOfEntityId;
    this.getWBLeftSideMenu();
    this.getNtrMenuData();
    this.shareService.partnersCapitalView.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      this.hideRightSidePanel = response;
    });
    this.shareService.closePreview.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => this.isPreviewPanelExpanded = response);
    this.shareService.refreshWindow.next(window);
    this.getLeftSideMenuSchedules(null, true, true);

    this.syncSubject
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        debounceTime(10),
        switchMap(obj => this.scheduleService.commonPutMethod('/sync', obj).pipe(
          catchError(e => {
            this.toaster.error(e.error);
            return of(null);
          })
        ))
      )
      .subscribe(response => {
        if(response?.status === 200){
          this.selectedSchedule() ? this.scheduleService.setSync(this.selectedSchedule()) : this.getLeftSideMenuSchedules(null, true);
        }else{
          this.scheduleService.updateSyncCallSpinner(false);
        }
      });
  }

  sideMenutoggleDrawer() {
    this.isSideMenuExpanded = !this.isSideMenuExpanded;
    this.shareService.sortingPosition.next(this.isSideMenuExpanded);
  }

  previewToggleDrawer() {
    this.isPreviewPanelExpanded = !this.isPreviewPanelExpanded;
    localStorage.setItem('isWorkBook','true');
  }

  getWBLeftSideMenu() {
    this.scheduleService.updateEngagementSchedule({
      engagementId: this.engagementData?.engagementsid,
      acctYear: +this.countableTimeZonePipe.transform(this.engagementData?.yearEnd, 'yyyy', 'UTC'),
      engagementDetails: this.engagementData
    });
    this.wbService.getWbLeftSide(this.engagementID).subscribe({
      next: res => {
        if (res.status === 200 && res?.data) {
          this.workBookLeftSideMenu = JSON.parse(res?.data);
          this.workBookLeftSideMenu.forEach(routingName => {
            if (routingName.uirouting === 'tb-ls-grouping') {
              routingName.routeUrl = '/trial-balance-working-sheet/tb-ls-grouping';
            } else if (routingName.uirouting === 'balancesheet') {
              routingName.routeUrl = '/trial-balance-working-sheet/balance-sheet';
            } else if (routingName.uirouting === 'incomeloss') {
              routingName.routeUrl = '/trial-balance-working-sheet/income-statement';
            } else if (routingName.uirouting === 'partnercapital') {
              routingName.routeUrl = '/trial-balance-working-sheet/partners-capital';
            } else if (routingName.uirouting === 'retainedearning') {
              routingName.routeUrl = '/trial-balance-working-sheet/retained-earnings';
            } else if (routingName.uirouting === 'notestofs') {
              routingName.routeUrl = '/trial-balance-working-sheet/fs-notes';
            } else if (routingName.uirouting === 'stockholdersequity') {
              routingName.routeUrl = '/trial-balance-working-sheet/Stockholdersequity';
            } else if (routingName.uirouting === 'cashflow') {
              routingName.routeUrl = '/trial-balance-working-sheet/cashflow';
            }
          });
          this.scheduleService.updateEngagementSchedule({leftSideMenu: this.workBookLeftSideMenu });
        }
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  isMenuEditable(data) {
    if (this.shareService.isFirmTemplatesNotesEditoropened) {
      this.toaster.error('Please save/cancel changes made to the note before proceeding');
    } else {
      this.isEditableMenu = true;
      this.subModuleId = data.submoduleid;
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    let count = 0;
    let data = [];
    moveItemInArray(this.workBookLeftSideMenu, event.previousIndex, event.currentIndex);

    this.workBookLeftSideMenu.forEach(element => {
      count = count + 1;
      data.push({
        'submoduleid': element.submoduleid,
        'engagementsid': this.engagementID,
        'ordernumber': count
      });
    });

    let inputParameters = JSON.stringify({
      'order': data
    });

    this.wbService.saveOrderChange(inputParameters).subscribe({
      next: () => {
        this.isEditableMenu = false;
        this.getWBLeftSideMenu();
        this.toaster.success('Workbook menu reorder successfully');
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  viewPage(routingName) {
    localStorage.setItem('WUUID', routingName.subModuleUUID);
    localStorage.setItem('workBookSubmoduleId', routingName.submoduleid);
    localStorage.setItem('isWorkBook','true');
    this.router.navigate([routingName.routeUrl]);
    this.closeLeftPanel();
  }

  saveLeftSideMenuName(data) {
    const saveLeftMenu = JSON.stringify({
      'submoduleid': data.submoduleid,
      'engagementsid': this.engagementID,
      'submodulename': data.submodulename,
      'Originalname': this.isOldSubModuleName
    });

    this.wbService.saveWbLeftSideNameChange(saveLeftMenu).subscribe({
      next: () => {
        this.isEditableMenu = false;
        this.getWBLeftSideMenu();
        this.toaster.success('Name saved successfully');
        this.shareService.leftSideMenuNameChange.next(true);
        this.wbService.sendMessage({id: data.submoduleid});
      }, error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  getNtrMenuData() {
    this.engApiService.getEngSetting(this.engagementID).subscribe({
      next: res => {
        localStorage.removeItem('RetainedEarningStatement');
        var data = JSON.parse(res);
        data[0].Financial.forEach(element => {
          if (element.engfinsettingid === 2) {
            this.engfinsettingid = 2;
            this.isyesno = element.isyesno;
          }
        });
      }
    });
  }

  closeLeftPanel() {
    if (window.innerWidth < 991) {
      this.drawer.close();
    }
  }

  public onResizePanelEnd(resizeData: ResizeModel) {
    resizeData.width < resizeData.minWidth ? this.drawer.close() : '';
  }

  public getLeftSideMenuSchedules(uuid?:string, isCallSync?: boolean, isInitialCall?: boolean) {
    this.scheduleService.getAllSchedules({
      'engagementId': this.engagementID,
      'acctYear': this.countableTimeZonePipe.transform(this.engagementData?.yearEnd, 'yyyy', 'UTC')
    }).subscribe({
      next: response => {
        if (response.status === 200 && response?.data) {
          const insideEngSchedule = structuredClone(response?.data);
          const beforeSyncSchedules = structuredClone(this.scheduleService.getEngagementSchedule().scheduleOriginalData);
          const originalSchedules = structuredClone(response?.data?.schedules) || [];
          const groupByUuid = response?.data.schedules?.length ? [...new Map(response?.data.schedules.map(item =>
            [item['uuid'], item])).values()] : [];
          this.leftSideMenuSchedules = response?.data;
          this.leftSideMenuSchedules.schedules = groupByUuid;
          this.leftSideMenuSchedules.schedules.sort((a, b) => a.sortOrder - b.sortOrder);
          this.leftSideMenuSchedules.routeUrl = '/trial-balance-working-sheet/schedules';
          this.scheduleService.updateEngagementSchedule({
            schedulesData: this.leftSideMenuSchedules,
            scheduleOriginalData: originalSchedules
          });
          if((isInitialCall || isCallSync)) {
            this.scheduleService.updateScheduleCount('set', this.leftSideMenuSchedules?.schedules?.length ? this.leftSideMenuSchedules?.schedules?.length : 0);
          }
          const isCallUpdateSortOrder = originalSchedules?.length === beforeSyncSchedules?.length;
          this.leftSideMenuSchedules.schedules?.length && this.isExpandSchedule.set(true);

            if(this.router.url.includes('/trial-balance-working-sheet/schedules') && !this.scheduleService.getSync()){
              if (this.leftSideMenuSchedules.schedules?.length) {
                this.activatedRoute.queryParams.pipe(take(1)).subscribe(param => {
                  if(uuid && this.leftSideMenuSchedules.schedules.find((schedule: any) => schedule.uuid == uuid) && !(param?.NoteId && this.leftSideMenuSchedules.schedules.find((schedule: any) => schedule.uuid == param?.NoteId))){
                    this.router.navigate(['/trial-balance-working-sheet/schedules'], { queryParams: {NoteId: uuid}});
                  } else if(!this.leftSideMenuSchedules.schedules.find((schedule: any) => schedule.uuid == param?.NoteId)){
                    this.router.navigate(['/trial-balance-working-sheet/schedules'], { queryParams: {NoteId: this.leftSideMenuSchedules.schedules[0].uuid}});
                  }
                });
              } else {
                const submoduleId = this.workBookLeftSideMenu.find((menu: any) => menu.uirouting === 'balancesheet')?.submoduleid;
                const button = document.getElementById(`${submoduleId}_workbookMenu`);
                if (button) {
                  button.click();
                }
              }
            } else if(this.scheduleService.getSync()){
              if (this.leftSideMenuSchedules.schedules?.length) {
                if(uuid && this.leftSideMenuSchedules.schedules.find((schedule: any) => schedule.uuid == uuid)){
                  if(this.router.url.includes('/trial-balance-working-sheet/schedules?NoteId='+uuid)){
                    this.scheduleService.setRefresh(uuid);
                    this.scheduleService.sendMessage({uuid: uuid});
                    this.scheduleService.updatePreview(uuid);
                  }else{
                    this.router.navigate(['/trial-balance-working-sheet/schedules'], { queryParams: {NoteId: uuid}});
                  }
                } else{
                  this.router.navigate(['/trial-balance-working-sheet/schedules'], {queryParams: {NoteId: this.leftSideMenuSchedules.schedules[0].uuid}});
                }
              }
              this.scheduleService.setSync(null);
            }
            if((isCallSync && !isCallUpdateSortOrder && beforeSyncSchedules?.length)){
              this.updateSortOrder(null);
            }
          this.wbService.sendMessage({uuid: uuid , type: 'schedule', id: null, data: insideEngSchedule });
          this.scheduleService.updateSyncCallSpinner(false);
        }
        else {
          (response.errors?.length || response.messages?.length) && this.scheduleService.handleMessage(response.errors?.length ? response.errors :  response.messages);
        }
      },
      error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  public deleteSchedule(schedule: any) {
    this.scheduleService.confirmDeleteSchedule(schedule, DIALOG_TYPES.SCHEDULE);
  }

  public onDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.leftSideMenuSchedules.schedules, event.previousIndex, event.currentIndex);
    this.updateSortOrder('reorder');
  }

  public updateSortOrder(uuid: string) {
    let scheduleIds = [];
    let filterSchedule = [];
    if (uuid && this.leftSideMenuSchedules.schedules.filter(schedule => schedule.uuid == uuid).length) {
      filterSchedule = this.leftSideMenuSchedules.schedules.filter(schedule => !(schedule.uuid == uuid));
    } else {
      filterSchedule = this.leftSideMenuSchedules.schedules;
    }
    if(!filterSchedule?.length){
      this.scheduleService.setRefresh();
      // this.wbService.sendMessage({type: 'schedule', id: null });
      return;
    }
    filterSchedule.forEach((schedule, index) => {
      schedule.sortOrder = index + 1;
      scheduleIds.push({
        id: schedule.id,
        sortOrder: schedule.sortOrder
      });
    });
    const payload = {
      engagementId: this.engagementID,
      acctYear: +this.countableTimeZonePipe.transform(this.engagementData?.yearEnd, 'yyyy', 'UTC'),
      sortDetails: scheduleIds
    };

    this.scheduleService.commonPutMethod('/reorder', payload).subscribe({
      next: response => {
          if(response.status === 200){
            uuid === 'reorder' && this.toaster.success('Schedules reordered successfully');
            this.scheduleService.setRefresh();
            // this.wbService.sendMessage({type: 'schedule', id: null });
          }
      },
      error: e => {
        this.toaster.error(e.error);
      }
    });
  }

  public createSchedule(event: Event) {
    event.stopPropagation();
    const config = this.scheduleUtil.createScheduleGroups(DIALOG_TYPES.MANUAL,(this.leftSideMenuSchedules?.schedules?.length || 0), null, false, true);
    this.dialog.open(SchedulesDialogComponent, config);
  }

  scheduleSyncAll(uuid?: string) {
    let obj = {
      'engagementId': this.engagementData?.engagementsid,
      'acctYear': +this.countableTimeZonePipe.transform(this.engagementData?.yearEnd, 'yyyy', 'UTC')
    }
    uuid && (obj['uuid'] = uuid);
    this.selectedSchedule.set(uuid);
    if(this.leftSideMenuSchedules?.schedules?.length){
      const selectedSchedule = this.leftSideMenuSchedules.schedules.find(schedule => (schedule.uuid == uuid));
      if(selectedSchedule?.isSyncRequired && !selectedSchedule?.isManuallyUpdate){
        this.scheduleService.updateSyncCallSpinner(true);
        this.syncSubject.next(obj);
      } else{
        this.navigateToSchedule(selectedSchedule?.uuid);
      }
    }
  }

  saveChangesSchedule(schedule: any){
    if(schedule?.uuid && !this.scheduleService.saveChanges.getValue() && this.router.url.includes('/trial-balance-working-sheet/schedules')){
      this.dialog.open(UnsavedChangesDialogComponent, { disableClose: true }).afterClosed().subscribe((result: boolean) => {
        if(result){
          (schedule?.isSyncRequired && !schedule?.isManuallyUpdate) ? this.scheduleSyncAll(schedule?.uuid) : this.navigateToSchedule(schedule?.uuid);
        }
      });
    }else{
      (schedule?.isSyncRequired && !schedule?.isManuallyUpdate) ? this.scheduleSyncAll(schedule?.uuid) : this.navigateToSchedule(schedule?.uuid);
    }
  }

  navigateToSchedule(uuid: string) {
    if(uuid?.trim().length){
      this.router.navigate(['/trial-balance-working-sheet/schedules'], { queryParams: {NoteId: uuid}});
    }
  }

}
